import React, { memo } from 'react';
export interface Product {
  id: string;
  title: string;
  tagline: string;
  type: 'card' | 'memorabilia';
  image: string;
  badge: 'Graded' | 'Autographed' | 'Collectible' | null;
}
export const ProductCard = ({
  product
}: {
  product: Product;
}) => {
  const isCard = product.type === 'card';
  const ctaLabel = isCard ? 'Shop Cards' : 'Shop Memorabilia';
  const ctaHref = isCard ? '#shop' : '#memorabilia';
  return <div className="group flex flex-col bg-white overflow-hidden border-4 border-ink shadow-comic hover:shadow-comic-hover hover:translate-x-[4px] hover:translate-y-[4px] transition-all duration-200" data-id="element-127">
      <div className="relative aspect-[4/5] bg-cream overflow-hidden p-4 flex items-center justify-center border-b-4 border-ink" data-id="element-128">
        {product.badge && <div className="absolute top-3 left-3 z-10 bg-scarlet text-white text-xs font-bold px-3 py-1 uppercase tracking-wider border-2 border-ink shadow-[2px_2px_0px_0px_#1A1A1A]" data-id="element-129">
            {product.badge}
          </div>}
        <img src={product.image} alt={product.title} className="object-contain w-full h-full group-hover:scale-105 transition-transform duration-500" data-id="element-130" />
      </div>
      <div className="p-4 flex flex-col flex-grow" data-id="element-131">
        <p className="text-silver text-xs font-bold uppercase tracking-wider mb-1" data-id="element-132">
          {product.tagline}
        </p>
        <h3 className="font-heading text-xl leading-tight text-ink mb-4 flex-grow" data-id="element-133">
          {product.title}
        </h3>
        <a href={ctaHref} className="mt-auto inline-flex items-center justify-center bg-scarlet text-white px-4 py-2 font-heading text-lg tracking-wider border-2 border-ink shadow-[4px_4px_0px_0px_#1A1A1A] hover:shadow-[1px_1px_0px_0px_#1A1A1A] hover:translate-x-[3px] hover:translate-y-[3px] transition-all outline-none min-h-[44px]" data-id="element-134">
          {ctaLabel}
        </a>
      </div>
    </div>;
};